import React from 'react';
import {Space, Tag} from 'antd';
import {useTranslation} from 'react-i18next';
import {ComplaintTaskRow} from '../../../../graphql/complaintTask/types';
import {formatDuration, timeliness} from '../complaintTaskUtils';

const COLOR: Record<string, string> = {
  responseOverdue: 'orange',
  resolveOverdue: 'red',
  responseLeft: 'blue',
  resolveLeft: 'green',
  onTime: 'green',
};
const NEAR_DUE_COLOR = 'gold';

/** 时效标签：响应超时 X / 处理超时 X / 响应剩 X / 处理剩 X（≤10 分钟变黄）/ 未超时。 */
const TimelinessTags: React.FC<{row: ComplaintTaskRow; serverNow?: string | null}> = ({row, serverNow}) => {
  const {t} = useTranslation();
  const tags = timeliness(row, serverNow);
  if (!tags.length) return <span className="text-gray-300">—</span>;
  return (
    <Space direction="vertical" size={2}>
      {tags.map((tag) => (
        <Tag key={tag.kind} color={tag.nearDue ? NEAR_DUE_COLOR : COLOR[tag.kind]} className="!mr-0">
          {t(`complaintTask.timeliness.${tag.kind}`, {duration: tag.ms !== undefined ? formatDuration(tag.ms) : ''})}
        </Tag>
      ))}
    </Space>
  );
};

export default TimelinessTags;
